import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import './login-switch.less';

class LoginSwitch extends React.PureComponent {
    render() {
        const { location } = this.props;

        return (
            <div className='login-switch'>
                {/* <Button type="link" onClick={() => (history.push('/recoverPwd'))}>
                    忘记密码
                </Button> */}
                <Link to="/login/recover">忘记密码</Link>
                {
                    location.pathname === '/login/merchant' ?

                        <Link to="/login">
                            密码/验证码登录
                        </Link>
                        :
                        <Link to="/login/merchant">
                            商户号登录
                        </Link>
                        // <Button type="link" onClick={() => (history.push('/login'))}>
                        //     密码/验证码登录
                        // </Button>
                        // :
                        // <Button type="link" onClick={() => (history.push('/login/merchant'))}>
                        //     商户号登录
                        // </Button>
                }
            </div>
        );
    }
}

export default (withRouter(LoginSwitch));
